import store from '../store/store';
import { action, select } from 'satcheljs/lib/legacy';
export default select({
    optionState: function () { return store; },
})(action('setBlockedSendersOption')(function setBlockedSendersOption(blockedSenders, state) {
    var optionState = state.optionState;
    optionState.blockedSenders = blockedSenders;
}));
//# sourceMappingURL=setBlockedSendersOption.js.map